import React from "react";

export interface IDynamicComponentProps {
    as: string;
}

const DynamicComponent = (props: IDynamicComponentProps & React.HTMLAttributes<HTMLElement>) => {
    const { as: Component, ...rest } = props;
    
    return (
        <Component {...rest} />
    );
};

export default DynamicComponent;
